import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_ESENCIAL, CHECKOUT_PREMIUM } from '../lib/links';
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function FinalCTA() {
  return <section className="w-full bg-forest px-5 py-20 sm:px-8 lg:py-28" data-id="element-47" data-mp="m3x04y62j5ko">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.55,
      ease: 'easeOut'
    }} className="mx-auto max-w-3xl text-center" data-id="element-48" data-mp="h6djjrlwegpk">
        <h2 className="font-display text-3xl leading-tight text-cream sm:text-5xl" data-id="element-49" data-mp="qy155bvrx3j4">
          El próximo domingo puede ser diferente.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-cream/70" data-id="element-50" data-mp="zx4s4qy2a32w">
          Elegí tu pack y empezá a cocinar con un sistema — no con miedo.
        </p>

        <div className="mx-auto mt-10 grid max-w-xl gap-3 sm:grid-cols-2" data-id="element-51" data-mp="2c6rc6bq0skpp">
          <div className="rounded-2xl border border-cream/15 bg-cream/5 p-5" data-id="element-52" data-mp="2h49jjxoe2rvl">
            <p className="text-sm text-cream/60" data-id="element-53" data-mp="2m1swmu9coyly">📘 Mega Pack Esencial</p>
            <p className="mb-4 mt-1 font-display text-3xl text-cream" data-id="element-54" data-mp="2r1nmcuhe3i5f">
              $19.990 ARS
            </p>
            <CTAButton size="md" href={CHECKOUT_ESENCIAL} className="!bg-cream !text-forest-dark hover:!bg-white" data-id="element-55" data-mp="2v4alzhkay7d6">
              Comprar
            </CTAButton>
          </div>
          <div className="rounded-2xl border border-wheat/40 bg-cream/5 p-5" data-id="element-56" data-mp="34tu42l06xx6z">
            <p className="text-sm text-wheat" data-id="element-57" data-mp="39rdjho8mkg0i">⭐ Pack Premium</p>
            <p className="mb-4 mt-1 font-display text-3xl text-cream" data-id="element-58" data-mp="3errsb8i1vtzl">
              $27.990 ARS
            </p>
            <CTAButton size="md" variant="secondary" href={CHECKOUT_PREMIUM} data-id="element-59" data-mp="3islhs6b55gul">
              Comprar
            </CTAButton>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-cream/60" data-id="element-60" data-mp="1jolesgx14pd0">
          {trust.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-61" data-mp="1showj1epjodg">
              <Icon className="h-4 w-4 text-wheat" aria-hidden="true" data-id="element-62" data-mp="1nq6su5lav9os" />
              {label}
            </li>)}
        </ul>
      </motion.div>
    </section>;
}